import { z } from 'zod';

export const PaymentEdgeModel = z.object({
  id: z.string().uuid(),
  isConnectedToSourceRoot: z.boolean(),
  sourceNodeId: z.string().uuid().nullish(),
  targetNodeId: z.string().uuid(),
  label: z.string().nullable(),
  projectId: z.string().uuid(),
});

export const PaymentEdgesModel = PaymentEdgeModel.array();

const PaymentEdgeFormBaseSchema = PaymentEdgeModel.pick({
  isConnectedToSourceRoot: true,
  sourceNodeId: true,
  targetNodeId: true,
}).extend({
  label: PaymentEdgeModel.shape.label.optional(),
});

export const PaymentEdgeFormSchema = PaymentEdgeFormBaseSchema.refine(
  (values) => values.isConnectedToSourceRoot || values.sourceNodeId,
  {
    path: ['sourceNodeId'],
    params: { i18n: 'errors.invalid_type_received_undefined' },
  },
);

export const PaymentEdgeMutationParamsSchema = PaymentEdgeFormBaseSchema.extend(
  {
    projectId: z.string().uuid(),
  },
);
